import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: "#5d1f4f",
        },
    },
});

export default theme;